module.exports = __webpack_public_path__ + "static/media/universiteit_leiden.2c4926e9.jpg";